import { PriceRow } from "@/interfaces/PriceRow";
import { defineComponent, PropType, ref } from "vue";

export default defineComponent({
  props: {
    prices: { type: Array as PropType<PriceRow[]>, required: true },
    sidebarMode: { type: Boolean, default: false },
  },
  setup(props) {
    const openRows = ref(
      props.prices.map((row) =>
        Boolean(hasExtraInfo(row) && row.extraInfoExpanded)
      )
    );

    const toggleInfo = (index: number): void => {
      openRows.value[index] = !openRows.value[index];
    };

    return { openRows, toggleInfo, hasExtraInfo };
  },
});

function hasExtraInfo(row: PriceRow): boolean {
  if (!row.extraInfo) {
    return false;
  }

  return Boolean(row.extraInfo.replace(/<[^>]*>/g, "").trim());
}
